module.exports = __webpack_public_path__ + "img/menulingua_logo_final_small.5c80f001.png";